<nz-layout class="layout">
  <nz-header> </nz-header>
  <nz-content>
    <div class="inner-content">
      <router-outlet></router-outlet>
    </div>
  </nz-content>
</nz-layout>
